<template>
  <div class="flag-icon" :style="style">
    <div
      v-if="isoCode"
      :class="`fi fib fi-${(isoCode || '').toLowerCase()}`"
      :style="style"
      :title="isoCode"
    />
    <div v-else class="flag-placeholder" :style="style">
      <span class="text-gray-400 text-xs">?</span>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

const props = withDefaults(defineProps<{ isoCode?: string; width?: number }>(), { width: 24 })

const style = computed(() => ({
  width: `${props.width}px`,
  height: `${Math.round(props.width / (4 / 3))}px`,
  borderRadius: '2px',
}))
</script>

<style scoped>
.flag-icon {
  display: inline-flex;
  overflow: hidden;
  flex-shrink: 0;
}
.flag-icon :deep(.fi) {
  background-size: contain;
  background-position: 50%;
  background-repeat: no-repeat;
  width: 100%;
  height: 100%;
}
.flag-placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px dashed #ccc;
  width: 100%;
  height: 100%;
}
</style>
